import type { FC } from 'react';

import Button from '../Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
} from '../ui/dialog';

type Props = {
  onForceGenerate: () => void;
  onCancel: () => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isLoading: boolean;
  cvData?: { id?: string; cv?: File };
};
const ForceGenerateDialog: FC<Props> = ({
  onCancel,
  onForceGenerate,
  onOpenChange,
  open,
  isLoading,
  cvData,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          {cvData
            ? `This resume already exists: ${cvData.cv?.name ?? cvData.id}`
            : 'Resume for this candidate already exists!'}
        </DialogHeader>
        <DialogDescription className="text-neutral-700">
          What would you like to do?
        </DialogDescription>
        <Button isLoading={isLoading} onClick={() => onForceGenerate()}>
          Keep both resumes
        </Button>
        <Button
          isLoading={isLoading}
          variant="secondary"
          onClick={() => onCancel()}
        >
          Cancel
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default ForceGenerateDialog;
